import { render, staticRenderFns } from "./InitialPoints.vue?vue&type=template&id=50a269cc"
import script from "./InitialPoints.vue?vue&type=script&lang=js"
export * from "./InitialPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports